import React, {useState , useCallback} from 'react';
import './Shop.css'
import Navbar from './Navbar'
import Footer from './footer'
import font from '../fonts/Aboreto/Aboreto-Regular.ttf'
import { useSelector, useDispatch } from "react-redux";
// import cartSlice, { addToCart } from './cartSlice';
// import { addItem, removeItem } from './storeByGPT'
import { Store } from './store/store';
import Cart from './cart';
import ProductSlider from './ProductSlider';
import { Link, Route, useMatch  } from 'react-router-dom';
import Product from './Product';
import product4 from '../Images/product4.png'
import { margin } from '@mui/system';

export default function ShoppingItems({ items }) {
  // const match = useMatch();
  const dispatch = useDispatch()
  const handleClick = useCallback((item) => {
    Store.dispatch({type: "ITEM_ADDED",item });
    console.log(Store.getState());
  }, [dispatch])
  // const [navCart, useNavCart] = useState(["No Item in cart"]);
  // function addToNavCart(item){
    //   useNavCart([currentCart => [...currentCart, item]])
    // }
    const [display, setDisplay] = useState(null);
    return (
      <div 
      style={{backgroundColor: "black"
      }}>
      <hr className='my-5'></hr>
    <div className="shopping-items my-5 col-md-12 mx-1 row text-center"
     style={{backgroundColor: "black",color: "white"}}>
      <h1><strong>Products</strong></h1>
      {items.map(item => (
        <div className="shopping-item col-md-4 my-2" key={item.id}
        style={{backgroundColor: "black"}}
            onMouseOver={()=>{setDisplay(item.id)}} onMouseLeave={()=>{setDisplay(null)}}>
              <Link to='/product' state={{item}} className='container' style={{}}>

          <img src={item.url || item.image}
          // src={item.image} 
          alt={item.name} width="100%" height="auto" className='image'
          onMouseOver={()=>{setDisplay(item.id)}} onMouseLeave={()=>{setDisplay(null)}}>
          </img>
          <div className='button' >
          {display === item.id && (
            <>
                  <Link className="btn addToCart" to='/product' state={{item}} style={{color:'black', transition: "all 1s ease-in-out",padding: 0,margin: 0 }}
                     >View Product Details</Link>
                  {/* <Link className='btn addToCart'
                    to={{
                      pathname: `${match.url}/product`,
                      state: { prop1: 'Hello' },
                    }}
                    render={(props) => <Product {...props} />}
                  >
                    My Component
                  </Link> */}
                </>
            )}
            </div>
            </Link>
            {/* <div class="container">
  <img src="https://images.unsplash.com/photo-1488628075628-e876f502d67a?dpr=1&auto=format&fit=crop&w=1500&h=1000&q=80&cs=tinysrgb&crop=&bg=" alt="" />
  <div class="button"><a href="#"> BUTTON </a></div>
</div> */}
          <h5 className='product-title' style={{fontFamily: "font"}}>{item.title}</h5>
          {item.discounted_price ? (
            <>
              <p className="original-price" style={{fontFamily: "font"}} ><del>${item.price}</del> <span className='mx-2'> ${item.discounted_price}</span></p>
            </>
          ) : (
            <>
            <p style={{fontFamily: "font"}}>${item.price}</p>
            </>
            )}
          {/* <p>{item.dicountedPrice}</p> */}
        </div>
      ))}
    </div>
      </div>
  );
}

